// Dependencies
import React, { Component } from 'react';
import banner from '../../assets/img/vector/housing.svg';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import ImageText from '../../subcomponents/ImageText';

import IconBlock from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/housing1.svg';
import img2 from '../../assets/img/flat/housing2.svg';
import img3 from '../../assets/img/flat/housing3.svg';
import FormularioContactoModal from '../../subcomponents/FormularioContactoModal';

class Housing extends Component {
  constructor(props) {
    super(props);
    this.state = { modalAsunto: 'Contacto' };
  }

  componentDidMount() {
    document.title = 'Housing - Insacom';
  }

  render() {
    let iconBlocks = [
      {
        id: 1,
        title: 'Respaldo de Energía',
        description:
          'Contamos con grupos electrógenos y sistema de UPS redundantes en todos nuestros nodos',
        img: img1
      },
      {
        id: 2,
        title: 'Conectividad Redundante',
        description:
          'Contamos con fibras por diferentes rutas físicas que nos conectan a los PITs más importantes del país',
        img: img2
      },
      {
        id: 3,
        title: 'Red Redundante',
        description: 'Infraestructura red diseñada con redundancia N+1',
        img: img3
      }
    ];

    const descripcion =
      'El mejor lugar para tus servidores con las condiciones ideales de funcionamiento. Olvídate de los gastos en espacio, enfriamiento y energía redundante, nosotros nos hacemos cargo.';

    return (
      <Section no-contact>
        <SectionContainer paddingBottom={'0px'} backgroundColor="#3a75a4">
          <ImageText
            color="white"
            image={banner}
            title="Housing"
            description={descripcion}></ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock content={iconBlocks}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <div className="col-lg-6 g-mb-30">
            <article className="w-100 d-sm-table g-bg-white">
              <div className="d-sm-table-cell text-center text-sm-left g-valign-middle g-brd-right--dashed--sm g-brd-gray-light-v4 g-pa-30">
                <div className="g-font-size-30 g-color-primary">2 UF</div>
                <em className="d-block g-font-style-normal g-font-weight-300 g-mt-minus-5 g-mb-20">
                  desde
                </em>
                <button
                  data-modal-target="#contacto-modal"
                  onClick={() => {
                    this.setState({ modalAsunto: 'Housing' });
                  }}
                  className="btn u-btn-outline-primary">
                  Contactar
                </button>
              </div>

              <div className="d-sm-table-cell text-center text-sm-left g-valign-middle g-pa-30">
                <h4 className="text-uppercase g-color-black g-font-size-default g-font-weight-700">
                  Housing
                </h4>
                <p className="mb-0">
                  Aloja tu equipamiento en alguno de los nodos que disponemos.
                </p>
              </div>
            </article>
          </div>
        </SectionContainer>
        <FormularioContactoModal asunto={this.state.modalAsunto} />
      </Section>
    );
  }
}

export default Housing;



// WEBPACK FOOTER //
// ./src/sections/datacenter/Housing.js